import { SchoolSpaViewModel } from "../schoolsApiSlice";
import ActivationSettings from "./ActivationSettings";
import SeatCount from "./SeatCount";
import UserAvatarSetting from "./UserAvatarSetting";
import NormativeSetting from "./NormativeSetting";

interface SchoolSettingsProps {
	schoolInfo: SchoolSpaViewModel;
	setSchoolInfo: (schoolInfo: SchoolSpaViewModel) => void;
	setErrorMessage: (message: string) => void;
}

export default function SchoolSettingsSection({
	schoolInfo,
	setSchoolInfo,
	setErrorMessage,
}: SchoolSettingsProps) {
	return (
		<section className="grid grid-cols-2 xl:grid-cols-4 space-y-3 mt-4 items-start">
			<ActivationSettings
				schoolInfo={schoolInfo}
				setSchoolInfo={setSchoolInfo}
				setErrorMessage={setErrorMessage}
			/>
			<SeatCount schoolInfo={schoolInfo} setErrorMessage={setErrorMessage} />
			<UserAvatarSetting
				schoolInfo={schoolInfo}
				setSchoolInfo={setSchoolInfo}
				setErrorMessage={setErrorMessage}
			/>
			<NormativeSetting
				schoolInfo={schoolInfo}
				setSchoolInfo={setSchoolInfo}
				setErrorMessage={setErrorMessage}
			/>
		</section>
	);
}
